import { render, staticRenderFns } from "./TeamNameWithRosteredProductCategories.vue?vue&type=template&id=3fdb7668&scoped=true&"
import script from "./TeamNameWithRosteredProductCategories.vue?vue&type=script&lang=js&"
export * from "./TeamNameWithRosteredProductCategories.vue?vue&type=script&lang=js&"
import style0 from "./TeamNameWithRosteredProductCategories.vue?vue&type=style&index=0&id=3fdb7668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdb7668",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/web apps/HMS_Web_App_Vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VImg,VTooltip})
